'use strict';

/*
	Access should be in the following form:

	pmt-access="permission/{permission}"
	pmt-access="permission/{permission}/location/{id}"
	pmt-access="group/{type}/{smartType|name}"
	pmt-access="group/{type}/{smartType|name}/role/{role}"
	pmt-access="group/{type}/{smartType|name}/permission/{permission}"
	pmt-access="role/{role}"
	pmt-access="role/{role}/location/{id}"
	*/

angular.module('PinMeTo.access').directive('pmtNoAccess', [
	'$animate',
	'$compile',
	'pmtAccessService',
	function ($animate, $compile, pmtAccessService) {
		return {
			multiElement: true,
			transclude: 'element',
			priority: 666,
			terminal: true,
			restrict: 'A',
			$$tlb: true,
			scope: {
				permission: '@pmtAccess'
			},
			link: function ($scope, $element, $attr, ctrl, $transclude) {
				let approved = function () {};

				let denied = function () {
					$transclude(function (clone) {
						clone[clone.length++] = $compile.$$createComment('end pmtAccess', $attr.pmtAccess);
						$animate.enter(clone, $element.parent(), $element);
					});
				};

				pmtAccessService.checkPermission($scope.permission).then(approved, denied);
			}
		};
	}
]);
